import React, { useState, useEffect } from 'react';
import { FiUsers, FiMapPin, FiCalendar, FiCheckCircle } from 'react-icons/fi';
import api from '../../utils/api';

const font = "'Outfit', sans-serif";
const BL = '#6366f1';
const C = { text: '#1e1b4b', sub: '#6b7280', border: '#e0e7ff', bg: '#eef2ff', white: '#fff' };

const HallAllocations = () => {
    // 🚧 This component requires fetching scheduled exams from the OLD DB
    // and matching them with halls from the NEW DB, then generating seating.

    return (
        <div style={{ fontFamily: font }}>
            <h1 style={{ fontSize: 24, fontWeight: 900, color: C.text, margin: '0 0 8px', letterSpacing: -0.5 }}>Hall Allocations</h1>
            <p style={{ color: C.sub, fontSize: 14, margin: '0 0 30px' }}>Assign students to specific examination halls and generate seating arrangements.</p>

            <div style={{ background: C.white, borderRadius: 20, border: `1.5px solid ${C.border}`, padding: 40, textAlign: 'center', boxShadow: '0 4px 12px rgba(99,102,241,0.05)' }}>
                <FiMapPin size={48} color={BL} style={{ opacity: 0.2, marginBottom: 16 }} />
                <h3 style={{ fontSize: 18, fontWeight: 800, color: C.text, margin: '0 0 8px' }}>Seating Allocation Module</h3>
                <p style={{ color: C.sub, fontSize: 14, maxWidth: 500, margin: '0 auto' }}>
                    The allocation engine requires student enrollment data from the legacy scheduling system to generate optimized seating plans across your configured halls.
                    <br /><br />
                    <em>(UI coming soon based on integration with existing student tables)</em>
                </p>
            </div>
        </div>
    );
};

export default HallAllocations;
